import {
    patchWeightUpdateRepo
} from "../repositories/newsletter"
import { createSlice } from "@reduxjs/toolkit";

import { postDebListingLiveSync } from "../slices/deblisting"
import { getdebListing } from "../slices/deblisting"


const weightUpdateSlice = createSlice({
    name: "weightUpdateReducer",

    initialState: {
        weightUpdateLoading: false,
        weightUpdateData: null,
        weightUpdateError: null,
    },

    reducers: {
        getWeigthUpdateLoading(state, action) {
            return {
                ...state,
                weightUpdateLoading: true,
            };
        },
        getWeigthUpdateSuccess(state, action) {
            return {
                ...state,
                weightUpdateLoading: false,
                weightUpdateData: action.payload,
            };
        },
        getWeigthUpdateFailure(state, action) {
            return {
                ...state,
                weightUpdateLoading: false,
                weightUpdateError: action.payload,
            };
        },
        clearGetWeigthUpdateReponse(state, action) {
            return {
                ...state,
                weightUpdateData: null,
                weightUpdateError: null,

            };
        },

    }
})
export const {
    getWeigthUpdateLoading,
    getWeigthUpdateSuccess,
    getWeigthUpdateFailure,
    clearGetWeigthUpdateReponse,

} = weightUpdateSlice.actions;


export const patchWeightUpdate = (params, user, filters) => {
    console.log("params",params);
    return async (dispatch) => {
        dispatch(getWeigthUpdateLoading());
        await patchWeightUpdateRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    //if it is been success then sudhir sir api call 
                    dispatch(getWeigthUpdateSuccess(response?.data));
                    // if (params?.items?.length > 0) {
                    //     dispatch(postDebListingLiveSync({ email: user?.data?.email, category: params?.category }));
                    // }
                    // refresh listing with applied filters
                    if (filters) {
                        dispatch(getdebListing(filters));
                    }

                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getWeigthUpdateFailure(error.message));
                }
            });
    };
};


export default weightUpdateSlice.reducer